import {
  blogErrorHandler,
  galleryErrorHandler,
  photoErrorHandler,
  sectionBgErrorHandler,
  slideBgErrorHandler,
} from './ErrorHandlers';

const imageErrorHandler = () => {
  blogErrorHandler();
  photoErrorHandler();
  galleryErrorHandler();
  sectionBgErrorHandler();
  slideBgErrorHandler();
};

export default imageErrorHandler;
